import React, { memo, useMemo, useState } from 'react'
import { ExtraSmallButton } from '../../../../custom'
import { ListItemIcon, ListItemText, MenuItem, Popover, Typography } from '@mui/material'
import Line from '../../../../../assets/icons/chartTypes/line'
import CurvedLine from '../../../../../assets/icons/plotTypes/curvedLine'
import StepLine from '../../../../../assets/icons/plotTypes/stepLine'
import Cross from '../../../../../assets/icons/plotTypes/cross'
import Circles from '../../../../../assets/icons/plotTypes/circles'
import AnalyticsManager from '../../../../../analytics/AnalyticsManager'
import { LineType } from 'lightweight-charts'
import { PlotTypesMenuMultiStrikeChart } from '../../../chart.typings'

type Props = {
    lineType: LineType,
    onSelected: (menuItem: LineType) => void
}

export const getPlotTypeIcon = (lineType: LineType) => {
    if (lineType === LineType.Simple) {
        return <Line />
    }
    if (lineType === LineType.Curved) {
        return <CurvedLine />
    }
    if (lineType === LineType.WithSteps) {
        return <StepLine />
    }
    if (lineType === LineType.Cross) {
        return <Cross />
    }
    if (lineType === LineType.Circle) {
        return <Circles />
    }
    return null
}

const OutputPlotTypesView = ({ lineType, onSelected }: Props) => {
    const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null)

    const selectedItem = useMemo(() => {
        return PlotTypesMenuMultiStrikeChart.find((menuItem) => menuItem.type === lineType)
    }, [lineType])

    const plotTypeIcon = useMemo(() => getPlotTypeIcon(lineType), [lineType])

    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget)
    }

    const onChange = (menuItem: LineType) => {
        onSelected(menuItem)
    }

    return (<>
        <ExtraSmallButton onClick={handleClick} variant="outlined" sx={{ borderRadius: 1, px: 0.25, py: 0 }}
                          color="inherit">
            {plotTypeIcon ? plotTypeIcon : <Typography sx={{
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                px: 0.5
            }}> {selectedItem?.label ?? ''}</Typography>}
        </ExtraSmallButton>
        <Popover
            elevation={3}
            open={Boolean(anchorEl)}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left'
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'left'
            }}
            anchorEl={anchorEl}
            sx={{ overflowY: 'auto' }}
            onClose={() => setAnchorEl(null)}
        >
            {
                PlotTypesMenuMultiStrikeChart.map((menuItem) => {
                    return <MenuItem selected={menuItem.type === lineType} key={menuItem.label} onClick={() => {
                        AnalyticsManager.logEvent('Setting Style Changed', { source: 'multistrike', type: 'line' })
                        onChange(menuItem.type)
                        setAnchorEl(null)
                    }}>
                        <ListItemIcon>
                            {getPlotTypeIcon(menuItem.type)}
                        </ListItemIcon>
                        <ListItemText>{menuItem.label}</ListItemText>
                    </MenuItem>
                })
            }
        </Popover>
    </>)
}

export default memo(OutputPlotTypesView)